import {createStyles, Theme} from "@material-ui/core";
import {styleColors} from "src/main.style";

export const TodoListStyle = (theme: Theme) => createStyles({
  root: {
    position: 'relative',
    width: '100%',
    height: '100%',
    minWidth: 0,
    minHeight: 0,
    boxSizing: 'border-box',
    paddingTop: '23px',
  },
  todosContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    paddingTop: '12px',
    // Clear the FAB's 100px bottom offset, 62px height and a 20px gap.
    paddingBottom: 'calc(182px + env(safe-area-inset-bottom, 0px))',
    scrollPaddingBottom: 'calc(182px + env(safe-area-inset-bottom, 0px))',
    borderRadius: '32px 32px 0 0',
    backgroundColor: styleColors.white,
    boxShadow: `0px -1px 23px ${styleColors.blackAlpha23}`,
    overflowY: 'auto',
    overflowX: 'hidden',
    WebkitOverflowScrolling: 'touch',
    overscrollBehaviorY: 'contain',
  },
  calendarSection: {
    flexShrink: 0,
    width: '100%',
    marginTop: '20px',
  },
  calendarDivider: {
    margin: '0 20px',
    border: 0,
    borderTop: `1px solid ${styleColors.greyLight2}`,
  },
  calendarInfo: {
    margin: '12px 20px',
    color: styleColors.greyDark1,
    fontSize: '11px',
    lineHeight: '16px',
    fontWeight: 300,
  },
  helpText : {
    color: styleColors.greyMedium1, 
    fontSize: '17px',  
    textShadow: `0px 1px 0px ${styleColors.whiteOverlay28}, 0px -1px 0px ${styleColors.blackInset33}`
  },
});



// WEBPACK FOOTER //
// ./src/components/todo/TodoList.style.ts